import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import {
  EmailLeadPageContainer,
  EmailLeadContainer,
} from './components';
import { gtmPageviewEvent } from '../../services/google-tag-manager';

import '../../components/forms/RegistrationForm/RegisterForm.scss';
import { xor } from 'lodash';

const useStyles = makeStyles((theme) => ({
  headerWrapper: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column-reverse',
    paddingTop: '16px',

    [theme.breakpoints.down('sm')]: {
      paddingTop: '32px',
      marginBottom: '16px',
    },
  },
  header: {
    marginBottom: 0,
    [theme.breakpoints.down('sm')]: {
      fontSize: '28px',
    },
  },
  eyebrowHeader: {
    marginBottom: '0.5rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
      lineHeight: '24px',
    },
  },
  emailLeadContainer: {
    padding: '32px 90px',
    maxWidth: '640px',
    [theme.breakpoints.down('sm')]: {
      padding: '32px 16px',
    },
  },
  formContainer: {
    marginTop: '16px',
  },
  subheader: {
    marginBottom: '16px',
    textAlign: 'center',
    fontFamily: 'Montserrat',
    color: '#53565A !important',
  },
  redirectCopy: {
    paddingTop: '32px',
    paddingBottom: 0,
    marginTop: 'auto',
    marginBottom: 0,
  }
}));

function ChildHoldingTablet() {
  const classes = useStyles();

  React.useEffect(() => {
    gtmPageviewEvent({
      // pageName: 'email-lead-page',
    });

    const timer = setTimeout(() => {
      window.location.replace(process.env.REACT_APP_BEGIN_CODESPARK_PDP);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <EmailLeadPageContainer>
      <EmailLeadContainer
        className={classes.emailLeadContainer}
        // use style to overwrite sass due to high specificity
        style={{ marginLeft: 'auto', marginRight: 'auto' }}
      >
        <Box className="">
          <img
            src={`${process.env.REACT_APP_CLOUDFRONT_URL}/accounts/child_holding_tablet.png`}
            alt="Child holding tablet"
          />
        </Box>

        <Box className={classes.headerWrapper}>
          <h5 className={classes.eyebrowHeader}>Redirecting you to codeSpark's new homepage</h5>
        </Box>
        <Box className={classes.headerWrapper}>
          <h2 className={`text-center ${classes.eyebrowHeader}`}>Redirecting...</h2>
        </Box>



<Box className={classes.headerWrapper} style={{ marginTop: 'auto' }}>
    <p className={classes.redirectCopy}>
      If you aren't automatically redirected, click <a href={`${process.env.REACT_APP_BEGIN_CODESPARK_PDP}/privacy`}>here</a>
    </p>
  </Box>

      </EmailLeadContainer>
    </EmailLeadPageContainer>
  );
}

export default ChildHoldingTablet;
